import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { styled, useTheme, useMediaQuery, CardContent, Grid } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { BrandclubPageType } from '@brandclub/types';
import moment from 'moment';

var MOBILE_COVER_IMAGE_WIDTH = 100;
var StyledCard = styled('div', {
    shouldForwardProp: function (prop) { return !['mobileView'].includes(prop.toString()); },
})(function (_a) {
    var mobileView = _a.mobileView, theme = _a.theme;
    return ({
        border: "1px solid ".concat(brandclub_colors.blueWhiteBorder),
        borderRadius: 8,
        boxShadow: 'none',
        padding: mobileView ? "0 20px 0 0" : '30px 26px',
        boxSizing: 'content-box',
        // ':hover': {
        //   boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.16)',
        // },
        '.MuiCardContent-root': {
            padding: '0 0 0 0 !important',
            '.page-cover-image': {
                borderRadius: mobileView ? '8px 0 0 8px' : 8,
                width: mobileView ? MOBILE_COVER_IMAGE_WIDTH : '100%',
                height: mobileView ? '100%' : 'auto',
                objectFit: mobileView ? 'cover' : 'unset',
            },
            '.page-date': {
                fontSize: mobileView ? 12 : 16,
                color: theme.palette.primary.main,
                margin: mobileView ? '9px 0 10px' : '10px 0 0',
            },
            '.page-title': {
                fontFamily: 'Poppins',
                fontSize: mobileView ? 18 : 24,
                fontWeight: mobileView ? 600 : 500,
                lineHeight: 1.42,
                height: "2.84em",
                textAlign: 'left',
                margin: '10px 0 0',
                color: theme.palette.primary.main,
                display: '-webkit-box',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
                overflowWrap: 'anywhere',
            },
            '.brand-name': {
                fontSize: 12,
                fontWeight: 600,
                color: theme.palette.primary.main,
                marginTop: 4,
            },
        },
    });
});
var PageCard = function (_a) {
    var _b;
    var displayName = _a.displayName, route = _a.route, routePrefix = _a.routePrefix, pageType = _a.pageType, previewImageUrl = _a.previewImageUrl, Link = _a.LinkComponent, brandEntity = _a.brandEntity, persistentQueryParams = _a.persistentQueryParams, pageCreatedTime = _a.createdTime, _c = _a.containerStyle, containerStyle = _c === void 0 ? {} : _c, _d = _a.titleStyle, titleStyle = _d === void 0 ? {} : _d, _e = _a.dateStyle, dateStyle = _e === void 0 ? {} : _e;
    var theme = useTheme();
    var smBreakpoint = theme.breakpoints.values.sm;
    var tabletView = useMediaQuery("(min-width: ".concat(smBreakpoint, "px)"));
    var mobileView = !tabletView;
    var completeRoute = "".concat(routePrefix).concat(route).concat(persistentQueryParams ? "?".concat(persistentQueryParams) : '');
    var brandName = (_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name;
    var createdTime = pageCreatedTime !== null && pageCreatedTime !== void 0 ? pageCreatedTime : new Date().getTime();
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCard, { style: containerStyle, mobileView: mobileView, className: "card-link" },
            React.createElement(CardContent, null,
                React.createElement(Grid, __assign({ container: true }, (mobileView
                    ? {
                        display: 'grid',
                        gridTemplateColumns: "".concat(MOBILE_COVER_IMAGE_WIDTH, "px auto"),
                        columnGap: '20px',
                    }
                    : {})),
                    React.createElement(Grid, { item: true, sx: { width: '100%' } },
                        React.createElement(Link, { to: completeRoute, style: { textDecoration: 'none' } },
                            React.createElement("img", { loading: "lazy", src: previewImageUrl, alt: "Cover image for ".concat(displayName), className: "page-cover-image" }))),
                    React.createElement(Grid, { item: true, width: '100%' },
                        React.createElement(React.Fragment, null,
                            pageType === BrandclubPageType.Editorial && !mobileView && (React.createElement("div", { className: "page-date", style: dateStyle }, moment(+createdTime * 1000).format('MMMM Do, YYYY'))),
                            React.createElement(Link, { to: completeRoute, style: { textDecoration: 'none' } },
                                React.createElement("div", { className: "page-title", style: titleStyle }, displayName)),
                            mobileView && (React.createElement("div", { style: { marginBottom: 10 } },
                                React.createElement("div", { className: "brand-name" }, brandName),
                                React.createElement("div", { className: "page-date", style: dateStyle },
                                    pageType,
                                    " \u2022 ",
                                    moment(+createdTime * 1000).format('MMMM Do, YYYY')))))))))));
};

export { PageCard as default };
//# sourceMappingURL=index.js.map
